import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/news.json";
import tags from "@/.sourceflow/news_tag.json";

export const useNews = ({ filters = null, limit = 8 } = {}) => {
  let collection = useSourceFlowCollection(data);

  if (filters && filters.length > 0) {
    let filterTags = tags?.category_values?.filter((tag) => tag.id.includes(filters)).map((tag) => tag.title.en);
    collection = collection.filter((article) => Array.isArray(article?.tag?.en) && article.tag.en.some((tag) => filterTags.includes(tag)));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useNews;
